import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { authClient } from "@core/clients";
import { VerificationCodeResponse } from "@core/types";

const useGetUcallerCode = (options?: UseMutationOptions<VerificationCodeResponse, any, { phone: string }>) =>
  useMutation(
    ["get-ucaller-code"],
    async ({ phone }): Promise<VerificationCodeResponse> => {
      const data = await authClient.getUcallerCode(phone);

      return data;
    },
    options
  );

export default useGetUcallerCode; 